import { FormattedMessage } from 'react-intl'

export default () => (
  <div className='resort-pricing-row unavailable no-rooms'>
    <h3>
      <FormattedMessage id='no_rooms' defaultMessage='There are no rooms' />
    </h3>
  </div>
)
